import React from "react";

import { Transaction } from "components/Transaction";

const TransactionPage = () => {
  return <Transaction />;
};

export default TransactionPage;
